export const verifyAttribute = {
	code: "Verification Code",
	submit: "Verify",
	submitting: "Verifying",
	toast: {
		errorSummary: "Verification Failed",
		errorDetail: "{{error}}",
	},
};
